import { useMemo } from "react";
import { Link } from "@tanstack/react-router";
import { Video } from "lucide-react";
import { resolveApiUrl } from "@/lib/api";
import { usePublicVideos } from "../hooks/use-public-videos";

/**
 * Small square shortcut into the public feed. Shows a live preview of a random
 * community clip when one exists, otherwise a placeholder icon.
 */
export function PublicPreviewButton() {
  const { data: videos } = usePublicVideos();

  const preview = useMemo(() => {
    if (!videos || videos.length === 0) {
      return null;
    }
    return videos[Math.floor(Math.random() * videos.length)]!;
  }, [videos]);

  return (
    <Link
      to="/public"
      aria-label="Open public videos"
      className="flex size-12 items-center justify-center overflow-hidden rounded-lg border border-white/15 bg-black/60 backdrop-blur-md transition-colors hover:border-white/40"
    >
      {preview ? (
        <video
          src={resolveApiUrl(preview.mediaUrl)}
          muted
          playsInline
          loop
          autoPlay
          preload="metadata"
          className="size-full object-cover"
        />
      ) : (
        <Video className="size-5 text-white/60" />
      )}
    </Link>
  );
}
